import { render, staticRenderFns } from "./DestinationGroupForm.vue?vue&type=template&id=d3f46670"
import script from "./DestinationGroupForm.vue?vue&type=script&lang=js"
export * from "./DestinationGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports